"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var PlayersComponent_1 = __importDefault(require("@/Components/Players/PlayersComponent"));
var SortArrayContext_1 = require("@/Components/Players/SortArrayContext");
function Players() {
    return (react_1.default.createElement(AppLayout_1.default, { title: "Players", renderHeader: function () { return (react_1.default.createElement("h2", { className: "header" }, "Players")); } },
        react_1.default.createElement(SortArrayContext_1.SortArrayProvider, null,
            react_1.default.createElement(PlayersComponent_1.default, { permissions: {
                    read: ["see-players", "anonymous", "global-players-read", "resource-read", "resource-group-read"],
                    write: ["global-players-write", "resource-write", "resource-group-write"],
                    manage: ["global-players-manager", "resource-manager", "resource-group-manager"],
                } }))));
}
exports.default = Players;
